import React from "react";
import Navbar from "../Navbar";
import { Outlet } from "react-router-dom";

const AdminLayout = () => {
  return (
    <>
      <Navbar path={"admin"} />
      <div className="mt-10">
        <Outlet></Outlet>
      </div>
    </>
  );
};

export default AdminLayout;
